import { useMutation, useQueryClient } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const savePost = async (postId: string) => {
	const response = await cmsClient.post("/saved-posts/", {
		social_post: postId
	});
	return response.data;
};

const useSavePost = () => {
	const queryClient = useQueryClient();

	return useMutation(savePost, {
		onSettled: () => {
			queryClient.invalidateQueries(["social-posts"]);
		}
	});
};

export default useSavePost;
